<div>
    <br><br><br>
    <div class="create">
        <img width="44%" style="margin-left: 30%;" src="../../assets/images/logo.png" alt="">

    </div>
</div>
<br>
<h4 style="margin-left: 39%;">Email Verified Successfully...</h4>
<button type="button" (click)="home()" class="border-0 bg-transparent p-0 h4 mb-0" style="margin-left: 41%; cursor: pointer;">Go To Home Page</button>